import(/* webpackMode: "eager" */ "/vercel/path0/src/app/waitlist/page.tsx");
